var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.toggleLoginMenu}},[_c('TotemRouterLink',{staticClass:"totem-link login-menu",attrs:{"color":"primary","label":_vm.$t('Menu.login'),"fullWidth":true,"loginMenu":true,"to":{ name: 'login' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }